import axios from "axios";
const Instance = axios.create({
  baseURL: "http://91.98.179.208:200/",
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("token_GPC_admin"),
  },
});
export default Instance;
